<template>
  <div class="single_sentence_writing">
    <precautions
      v-if="selectedStep === 0"
      :title="questionData.Name"
      :level="level"
      :unit="unit || currentName"
    />

    <!-- START -->
    <div class="d-flex justify-content-center mt-3" v-if="selectedStep === 0">
      <a
        class="btn gept_main_bg4 text-white px-5 py-2 rounded-pill font-weight-bold"
        @click="getStart()"
      >
        {{ $t('GEPT.common.start') }}
      </a>
    </div>

    <!-- 作答 -->
    <div
      v-if="selectedStep === 1 && qData"
      class="single_sentence_writing_inner p-2"
    >
      <!-- 上方說明 -->
      <div class="d-flex justify-content-between align-items-center bg-white mb-2 instruction-card">
        <div class="d-flex align-items-center p-2">
          <h6 class="font-semibold mb-0 text-left">
            {{ $t('GEPT.writing.rewriteInstruction') }}
          </h6>
        </div>

        <div class="d-flex align-items-center p-2">
          <div
            class="p-2 border-1 rounded m-1 gept_main_color4 border_main2 font-semibold timer-box"
          >
            {{ formatTime(answer_count) }}
          </div>
        </div>
      </div>

      <!-- 題目列表 -->
      <div class="writing_inner scroll-bar mb-3">
        <div v-for="(item, index) in qData" :key="index">
          <div class="bg-white p-4 my-3 text-left section-card">
            <p class="gept_main_color h5 font-semibold mb-3 text-left">
              {{ sectionDisplayTitle(index, item.Name) }}
            </p>
            <p class="font-semibold mb-0">{{ item.Description }}</p>
          </div>

          <div
            class="row question-row"
            v-for="(child, index2) in item.Questions"
            :key="index2"
          >
            <!-- 題目 -->
            <div class="col-md-6 p-2 question-column">
              <div class="bg-white d-flex align-items-center rounded h-100 overflow-hidden question-card">
                <div
                  class="py-4 gept_main_bg7 text-white text-center h-100 d-flex align-items-center justify-content-center question-index"
                  style="width:64px"
                >
                  {{ index2 + 1 }}
                </div>
                <div
                  class="flex-1 p-2 font-weight-bold text-left question-text"
                  v-html="return_user_text(child.Title)"
                ></div>
              </div>
            </div>

            <!-- 作答框 -->
            <div class="col-md-6 p-2 answer-column">
              <textarea
                v-model="child.Answer"
                :disabled="!isCanActive"
                :id="`textarea${index}${index2}`"
                rows="2"
                class="form-control bg-white p-3 answer-textarea"
                :placeholder="$t('GEPT.writing.placeholderAnswer')"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部按鈕 -->
      <div class="d-flex justify-content-center">
        <a class="btn-default gept_main_bg5 text-white m-2 d-inline-block pointer"
          @click="toggleReport()">
          {{ geptNextActionLabel(!isLastGroup && $route.name === 'formal_exam') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/store/api'
  import precautions from '@/components/AiHelper/GEPT/precautions'
  import allJs from '@/components/AiHelper/all.js'
  import formal_examJs from '@/components/AiHelper/examJs_gept.js'
  import geptI18n from '@/components/AiHelper/GEPT/i18n'
  export default {
    name: 'single_sentence',

    data () {
      return {
        labels: ['一', '二', '三'],
        isShowTitle: false,
        isCanActive: false, // 可以動作

        selectedStep: 0,
        questionNumber: 0, //第幾題

        selectTipsIdx: -1,
        selectTipsIdx2: -1,

        timer: null,

        // 回答
        answer_count: 0,
        textVal: null,

        qData: null

        // selectItemIdx: -1
      }
    },
    mixins: [
      allJs,
      formal_examJs,
      geptI18n
    ],
    props: {
      questionData: {
        type: Array
      },
      unitTitle: {
        type: String
      },
      unit: {
        type: String
      },
      isLastGroup: {
        type: Boolean,
        default: false
      },
      level: {
        type: String
      },
      currentName: {
        type: String
      }
    },
    components: {
      precautions
    },
    computed: {
      textLength () {
        if (this.textVal) {
          let words = this.textVal.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "").split(" ")
          let wordCount = words.filter(word => word.length > 0).length
          return wordCount
        }
        return 0
      }
    },
    mounted () {
    },
    methods: {
      getStart () {
        this.selectedStep = 1
        this.isCanActive = true
        this.setArray()
        this.stopWatch()
      },

      setArray () {
        if (this.questionData) {
          this.qData = this.questionData
        }
      },

      stopWatch () {
        let self = this
        self.timer = setInterval(() => {
            self.answer_count++

            if (self.answer_count === 1 * 60 * 60) {
              clearInterval(self.timer)
              self.isCanActive = false
            }
          }, 1000
        )
      },

      formatTime (seconds) {
        const hours = Math.floor(seconds / 3600)
        const minutes = Math.floor((seconds % 3600) / 60)
        const secs = seconds % 60

        const formattedTime = [
            hours.toString().padStart(2, '0'),
            minutes.toString().padStart(2, '0'),
            secs.toString().padStart(2, '0')
        ].join(':')

        return formattedTime
      },

      reStart () {
        Object.assign(this.$data, this.$options.data())
      },

      alertTips () {
        let self = this
        return self.$swal.fire({
          title: this.$t('GEPT.alerts.answerHint'),
          html: this.$t('GEPT.writing.paragraphHint'),
          showCloseButton: true,
          showConfirmButton: false,
          focusConfirm: false,
          showDenyButton: false,
          customClass: {
            container: '',
            popup: 'p-0 max-w-3xl w-100',
            header: 'text-white gept_main_bg py-2',
            title: 'text-white m-0 text-2xl py-2',
            closeButton: 'top-0 right-0 position-absolute',
            htmlContainer: 'p-4 font-bold leading-loose mb-6 text-left',
            actions: 'mb-4 mt-5',
            confirmButton: 'submitButton-gept',
            denyButton: 'denyButton-gept',
          }
        })
      },

      async toggleReport () {
        let self = this
        // eslint-disable-next-line
        let isGuideLink = (self.isLastGroup && self.$route.name === 'formal_exam') || (self.$route.name === 'practice_speaking') ? true : false
        let allAnswersFilled = self.qData.every(section => section.Questions.every(question => question.Answer.trim() !== ""))

        if (allAnswersFilled) {
          if (self.$route.name === 'practice_speaking' && await self.checkSubmitReport(self.unitTitle, self.questionData.Name)) {
            self.finish_exams(self.$route.query.record_id, self.questionData.Name, isGuideLink)
          } else if (self.$route.name === 'formal_exam' && !self.isLastGroup) {
            for (let value of self.qData) {
              for (let value2 of value.Questions) {
                let qId = value2.Id
                let Answer = value2.Answer
                await self.post_gept_records_byFormal(self.$route.query.record_id, qId, this.currentName, Answer, null)
              }
            }
            self.$nextTick(() => {
              if (!self.isLastGroup) {
                self.$emit('guideNextType')
              } else {
                self.post_gept_records_finish(self.$route.query.record_id)
              }
            })
          }
        } else {
          this.finish_error_swal()
        }
      },

      toggleTips (idx, idx2) {
        this.selectTipsIdx = idx
        this.selectTipsIdx2 = idx2
      },

      sectionDisplayTitle (index, name) {
        return [this.geptPartLabel(index), this.geptDisplayText(name)].filter(Boolean).join('\u3000')
      },

      return_user_text (text) {
        return text.replace(/(?:\r\n|\r|\n)/g, '<br/>')
      }
    }
  }
</script>

<style lang="scss" scoped>
.single_sentence_writing {
  .single_sentence_writing_inner {
    .writing_inner {
      height: calc(61vh);
      overflow-y: scroll;
      overflow-x: hidden;
    }
    .instruction-card {
      gap: 0.5rem;
    }
    .timer-box {
      white-space: nowrap;
    }
    .section-card {
      line-height: 1.5;
    }
    .question-card {
      min-height: 100%;
    }
    .question-index {
      flex: 0 0 64px;
    }
    .question-text {
      min-width: 0;
      line-height: 1.5;
      overflow-wrap: anywhere;
    }
    .answer-textarea {
      min-height: 88px;
      line-height: 1.5;
      resize: vertical;
    }
    .col {
      flex: 1;
    }
    .item-outer2 {

    }
    .item-outer3 {
    }
    .active {

    }

    .item_border_arrow_active{
      &:after {
        background-image: url('~@/assets/image/gept/arrow_active.jpg') !important;
      }
    }
    .item_img {
      min-height: 320px;
      .check {
        top: 45%;
        left: 50%;

        transform: translate(-50%, -50%);
      }
    }
    .item_text {
      min-height: 120px;
      height: 20%;
    }

    @media (max-width: 767.98px) {
      .instruction-card {
        align-items: flex-start !important;
        flex-wrap: wrap;
        padding: 0.75rem;
      }
      .instruction-card h6 {
        font-size: 1rem;
        line-height: 1.65;
      }
      .timer-box {
        margin-left: auto !important;
      }
      .writing_inner {
        height: calc(100vh - 250px);
        min-height: 360px;
        padding-right: 2px;
      }
      .section-card {
        margin: 0.75rem 0 !important;
        padding: 1rem !important;
      }
      .section-card .h5 {
        font-size: 1.05rem;
        line-height: 1.4;
      }
      .question-row {
        display: block;
        margin: 0 0 0.85rem;
      }
      .question-column,
      .answer-column {
        padding: 0.35rem 0 !important;
      }
      .question-card {
        align-items: stretch !important;
        min-height: auto;
      }
      .question-index {
        flex-basis: 42px;
        width: 42px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }
      .question-text {
        padding: 0.75rem !important;
        font-size: 1rem;
        line-height: 1.45;
      }
      .answer-textarea {
        min-height: 84px;
        font-size: 1rem;
      }
      .btn-default {
        width: 100%;
        max-width: 280px;
        text-align: center;
      }
    }
  }
}
</style>
